import React from 'react';
import LocationTemplate from './LocationTemplate';

const FountainPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Fountain"
      stateName="North Carolina"
      countyName="Pitt"
      zipCodes={["27829"]}
      latitude={35.6693}
      longitude={-77.6339}
      population={427}
      historicalFact="Named for the natural springs or 'fountains' in the area; incorporated in 1901."
      nearbyTowns={[
        "Farmville, NC",
        "Winterville, NC",
        "Greenville, NC",
        "Bethel, NC",
        "Snow Hill, NC",
        "Stantonsburg, NC",
        "Walstonburg, NC",
        "Rocky Mount, NC"
      ]}
    />
  );
};

export default FountainPage;